import React from "react";
import { TextField } from "@mui/material";

const CustomTextArea = ({ 
  label, 
  placeholder, 
  minRows = 2,
  maxRows = Infinity, 
  value, 
  onChange, 
  fullWidth = true, 
  ...props 
}) => {
  return (
    <TextField
      label={label}
      multiline
      minRows={minRows}
      maxRows={maxRows}
      fullWidth={fullWidth}
      placeholder={placeholder}
      variant="outlined"
      size="small"
      value={value}
      onChange={onChange}
      sx={{ 
        mb: 1,
        '& .MuiInputBase-root': {
          overflow: 'hidden !important'
        },
        '& .MuiInputBase-input': {
          overflow: 'hidden !important'
        }
      }}
      {...props}
    />
  );
};

export default CustomTextArea;